/**
 * 线索确认收费统计
 */
import { CLUEPAYSTATISTICS } from '../types';

export default {
    name: `${CLUEPAYSTATISTICS}`,
    path: '/cluePayStatistics',
    component: () => import(/* webpackChunkName: 'cluePayStatistics' */ '@/views/cluePayStatistics/'),
    redirect: { name: `${CLUEPAYSTATISTICS}Index` },
    meta: {
        title: '线索确认收费统计',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${CLUEPAYSTATISTICS}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'cluePayStatistics' */ '@/views/cluePayStatistics/home/Home.vue'),
        },
    ],
};
